import React from "react";
import { Link } from "react-router-dom";

export default function HubButton({
  to,
  title,
  subtitle,
  image,
}) {
  return (
    <Link to={to} className="hub-button">
      <div className="hub-avatar">
        <img src={image} alt={title} />
        <span className="hub-avatar-glow" />
      </div>

      <div className="hub-button-content">
        <div className="hub-button-title">{title}</div>
        <div className="hub-button-subtitle">{subtitle}</div>
      </div>
    </Link>
  );
}